import React, { useState } from "react";
import { Routes, Route } from "react-router-dom";
import Layout from "./components/Layout";
import DashLayout from "./components/DashLayout";
import DbDiagram from "./components/DbDiagram";
import Results from "./components/Results";
import { useNavigate } from "react-router-dom";
import Home from "./components/Home";

export const selectedDbContext = React.createContext("");
function App() {
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedDb, setSelectedDb] = useState("Store");

  const [results, setResults] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const handleSearch = async (selectedDb) => {
    const endpoint = selectedDb === "Store" ? "/store" : "/employee";
    setIsLoading(true);
    navigate("/results");
    let query = searchQuery;
    if (!searchQuery.endsWith("?")) {
      query = `${searchQuery}?`;
    }
    const baseUrl =
      process.env.NODE_ENV === "production"
        ? "https://server-sqltranslated.onrender.com"
        : "http://localhost:5000";
    const response = await fetch(`${baseUrl}${endpoint}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        prompt: query,
      }),
    });
    const data = await response.json();
    setResults(data);
    setIsLoading(false);

    console.log(data);
  };
  return (
    <selectedDbContext.Provider value={{ selectedDb, setSelectedDb }}>
      <Routes>
        <Route
          path="/"
          element={
            <Home
              searchQuery={searchQuery}
              setSearchQuery={setSearchQuery}
              results={results}
              setResults={setResults}
              isLoading={isLoading}
              setIsLoading={setIsLoading}
              handleSearch={handleSearch}
              selectedDb={selectedDb}
              setSelectedDb={setSelectedDb}
            />
          }
        />
        <Route
          path="/results"
          element={
            <Results
              data={results}
              searchQuery={searchQuery}
              setSearchQuery={setSearchQuery}
              handleSearch={handleSearch}
              selectedDb={selectedDb}
              isLoading={isLoading}
            />
          }
        />
        <Route path="/store" element={<DbDiagram imageName="Store" />} />
        <Route path="/employee" element={<DbDiagram imageName="Employees" />} />
      </Routes>
    </selectedDbContext.Provider>
  );
}

export default App;
